import React, { JSX } from 'react';
import { Add, WorkOutline } from '@mui/icons-material';
import { Box, Tab, Tabs } from '@mui/material';
import { JobCreator } from 'components/JobCreator';
import { JobsView } from 'components/ui/JobsView';
import { LoginRestricted } from 'components/ui/LoginRestricted';
import { Job } from 'types/types';

function WorkAddIcon(): JSX.Element {
  return (
    <Box position="relative" display="inline-flex" sx={{ lineHeight: '30px', mb: '6px' }}>
      <WorkOutline sx={{ fontSize: 24 }} />
      <Add
        sx={{
          position: 'absolute',
          bottom: -2,
          right: -2,
          fontSize: 14,
          bgcolor: 'background.paper',
          borderRadius: '50%',
          boxShadow: 1,
        }}
        color="primary"
      />
    </Box>
  );
}

interface JobDescriptionStepProps {
  jobTab: string;
  user: { id?: string } | null;
  guest: unknown;
  selectedJob: Job | null;
  onTabChange: (event: React.SyntheticEvent, value: string) => void;
  onJobsSelected: (job: Job) => void;
}

function JobDescriptionStep({
  jobTab,
  user,
  guest,
  selectedJob,
  onTabChange,
  onJobsSelected,
}: JobDescriptionStepProps): JSX.Element {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 0,
        maxHeight: 'min-content',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          m: 0,
        }}
      >
        <Tabs value={jobTab} onChange={onTabChange} centered>
          <Tab value="select" icon={<WorkOutline />} label="Select Job" />
          <Tab value="create" icon={<WorkAddIcon />} label="Create Job" />
        </Tabs>
      </Box>
      {jobTab === 'select' && (
        <JobsView
          sx={{
            display: 'flex',
            position: 'relative',
            minHeight: 0,
            maxHeight: 'min-content',
            flexGrow: 1,
          }}
          selectable={false}
          onRowClick={onJobsSelected}
          selectedJobId={selectedJob?.id}
          showDetailsPanel={false}
        />
      )}
      {jobTab === 'create' && user && <JobCreator onSave={onJobsSelected} />}
      {jobTab === 'create' && Boolean(guest) && (
        <LoginRestricted>
          <JobCreator onSave={onJobsSelected} />
        </LoginRestricted>
      )}
    </Box>
  );
}

export { JobDescriptionStep };
